import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const BooleanImageIconCellStyled = styled.div.attrs<IStyledAttributes>({
  className: "boolean-image-icon-cell",
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* Fixed box: tall emoji glyphs (e.g. pin) overflow the row through font metrics, not font-size. */
  width: 20px;
  height: 20px;
  min-width: 20px;
  overflow: hidden;
  font-size: 16px;
  line-height: 1;
  cursor: default;
`;
